module.exports = __webpack_public_path__ + "img/Products.f72c1817.jpg";